import React from 'react';
import { GECKO_CONSTS, GeckoFields } from '@geckolabs/gecko-react-ui';
import DateUtils from '../../../../services/DateUtils';

const formatOptionLabel = (start, end) => {
    return DateUtils.isSameDay(start, end) ?
        `${DateUtils.hourMinute(start)} - ${DateUtils.hourMinute(end)}` :
        `${DateUtils.dateMonthYearHourMinute(start)} - ${DateUtils.dateMonthYearHourMinute(end)}`;
};

export const SessionTimeSelect = ({sessionTimes, sessionTimeId, setSessionTimeId}) => {
    const options = sessionTimes.map(time => ({
        label: formatOptionLabel(time.start_datetime, time.end_datetime),
        value: time.id,
    }));
    return (
        <GeckoFields
            fields={[{
                key: 'sessionTimeId',
                type: GECKO_CONSTS.FIELD_TYPE_SELECT,
                options,
                width: '100%',
                label: null,
                placeholder: 'Select a Session',
                clearable: false
            }]}
            values={{sessionTimeId}}
            handler={(key, value) => setSessionTimeId(value)}
        />
    );
};

export default SessionTimeSelect;